
import { Injectable } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class SharedService {
    private _lettres =
    [
        "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K",
        "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V",
        "W", "X", "Y", "Z"          
    ]; 
    constructor() {

    }

  

    generatorPolice(){
        let rand =  Math.floor(Math.random() * (26));// Math.random() * (25 - 0);// Math.random();
        let cpt =  Math.floor(Math.random() * (1000 - 1)) + 1;// Math.random() * (25 - 0);// Math.random();
  
        return cpt+this._lettres[rand];
    }

    ConvertDMYorYMD(dateinput, format: string="d/m/y") {
        
        // let result0=dateinput.substring(6, 10)
        // console.log(Number.isNaN(dateinput.substring(6, 10) * 1));
        
        let result
        if (!Number.isNaN(dateinput.substring(6, 10) * 1)) {
              if (dateinput.includes("/")) {
                  dateinput.replace(/\//g,"-")
              }else if (dateinput.includes("-")){
                dateinput = dateinput.split('-').reverse().join('-')
              }
           // dateinput = dateinput.split('-').reverse().join('-')
        }
        function pad(s) { return (s < 10) ? '0' + s : s; }
        var d = new Date(dateinput)
        if (format == "d/m/y") {
            result = [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('-')
        } else {
            result = [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
        }

        return result
    }

    getTimeStampFromToday() {
        var now = new Date();
        
        // var date = now.getUTCFullYear() + '-' +
        //              (now.getUTCMonth()+1) + '-' +
        //              (now.getUTCDate());
        var dte = Math.round((new Date(now.getFullYear(), now.getMonth(), now.getDate())).getTime() / 1000)
        // var dte = Math.round((new Date(date)).getTime()/1000)
        // 86400000;
        return (dte);
    }

    getTimeStampFromAnyDate(dt) {
        //const now = new Date();
        // be careful !!! dt must be yyyy-mm-dd
        let deb = new Date(dt)
  
       return Math.round((new Date(deb.getFullYear(), deb.getMonth()+1, deb.getDate())).getTime() / 1000)
        /// 86400000;

    }

    TimeStampToformatDMY(timeStamp) {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        var d = new Date(timeStamp * 1000)
        //var d = new Date(inputFormat)
        return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('-')

    }


    getDateSepar(){
        const d = new Date();

        function pad(s) { return (s < 10) ? '0' + s : s; }

       return {
                "J":pad(d.getDate()),
                "M": pad(d.getMonth() + 1), 
                "A":d.getFullYear(),
                "h":pad(d.getHours()+1),
                "m":pad(d.getMinutes()),
                "s":pad(d.getSeconds())
            }

    }


    getDateWithTimeDMY() {
        const now = new Date();

        let ann=now.getFullYear();
        const date =(now.getDate())<10 ? `0${now.getDate()}-`:`${now.getDate()}-`;
        const moi=(now.getMonth()+1)<10 ? `0${now.getMonth()+1}-`:`${now.getMonth()+1}-`;

        const h =(now.getHours()+1)<10 ? `0${now.getHours()+1}:`:`${now.getHours()+1}:`;
        const m=(now.getMinutes())<10 ? `0${now.getMinutes()}:`:`${now.getMinutes()}:`;
        const s=(now.getSeconds())<10 ? `0${now.getSeconds()}`:`${now.getSeconds()}`;
        const time = h + m + s;

        return (date+moi+ann+' ' + time);
    }

    getDateWithTime() {
        const now = new Date();
        function pad(s) { return (s < 10) ? '0' + s : s; }
        // const date = now.getUTCFullYear() + '-' +
        //     (now.getUTCMonth() + 1) + '-' +
        //     now.getUTCDate();
        // const time = now.getUTCHours() + ':' +
        //     now.getUTCMinutes() + ':' +
        //     now.getUTCSeconds();

            const date=  [now.getFullYear(),pad((now.getMonth() + 1)),pad(now.getDate())].join('-');
            const time= [pad(now.getUTCHours()+1),pad(now.getUTCMinutes()),pad(now.getUTCSeconds())].join(':');
             
        return (date + ' ' + time);
    }

    getDate(now:Date=new Date()) {
       // const now = new Date();
       function pad(s) { return (s < 10) ? '0' + s : s; }
       
        return [now.getFullYear(),pad(now.getMonth() + 1),pad(now.getDate())].join('-');
    }

    AddDays(dayMajorer: string, nbrjour: number) {
        //getDate récupère le jour de la date passée dans date     
        let dt = new Date(dayMajorer)
        
        var jrs = dt.getDate() * 1 + nbrjour * 1
        dt.setDate(jrs)   
        // console.log(dt);
        // dt.split('T')[0]; 
        return dt
    }
    DayOfyear(dtejour: Date): number {
        let b = new Date(dtejour)
        let a = b.getFullYear()
        let d = new Date(a, 1, 1)
        let f = new Date(a, 12, 31)
        return this.diffDays(d, f) * 1 + 1;
    }
    diffDays(deb, fin): any {
        
        deb = new Date(deb);
        fin = new Date(fin);
        var db = deb.getTime() / 86400000;
        var df = fin.getTime() / 86400000;
        const res = new Number(df - db).toFixed(0);
        return res;
    }
    eparateurMil(nbr) {
        var nombre = '' + nbr;
        var retour = '';
        var count = 0;

        for (var i = nombre.length - 1; i >= 0; i--) {
            if (count != 0 && count % 3 == 0)
                retour = nombre[i] + ' ' + retour;
            else retour = nombre[i] + retour; count++;
        }
        //alert('nb : ' + nbr + ' => ' + retour);
        return retour;
    }


    isFieldValid(form: FormGroup, field: string): boolean {
        // console.log(form.get(field))
        return (!form.get(field).valid && form.get(field).touched);
    }
    ValidPass(form: FormGroup, conffield: string, field: string): boolean {
        // console.log(form.get(field))
        if (form.get(field).touched && form.get(conffield).touched) {

            return (form.get(field).value !== form.get(conffield).value)

        }
        return false;
    }

    displayFieldCss(form: FormGroup, field: string) {
        return {
            'has-error': this.isFieldValid(form, field),
            'has-feedback': this.isFieldValid(form, field)
        };
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }
}